

import React, { useEffect, useRef } from 'react';
import '../../../assets/css/screens/customer/termsconditions/TermsConditions.css'; // External CSS file import
import MyNavbar from '../../../components/customer/home/Navbar/MyNavbar';
import Myfooter from '../../../components/customer/home/footer/Myfooter';
import Topbar from '../../../components/customer/home/topbar/Topbar';
import {
  FileText, Shield, Scale, CreditCard,
  Ban, RefreshCw, AlertCircle
} from 'lucide-react';
import ScrollToTop from '../../general/scrolltotop/ScrollToTop';


const SECTIONS = [
  {
    icon: <FileText size={20} />,
    title: "1. Acceptance of Terms",
    text: "By accessing or using Picks4Tips, you agree to comply with these Terms and Conditions. If you do not agree with any part of these terms, you should not use our platform or its services.",
  },
 {
  icon: <CreditCard size={20} />,
  title: "4. Payments & Payouts",
  text: "Payments for completed jobs are processed securely through the Picks4Tips platform. Service responders are required to connect their Stripe account before receiving payouts. Once a job is completed and payment is eligible for release, earnings will be transferred to the service responder's connected Stripe account in accordance with the platform's payment process. Applicable platform fees or commissions may be deducted where required.",
},

  {
    icon: <Scale size={20} />,
    title: "3. Service Provider Responsibilities",
    text: "Service providers are required to complete KYC verification before offering services on Picks4Tips. Providers must maintain professional conduct, deliver services as agreed, and ensure that all profile information remains accurate and up to date.",
  },
  {
    icon: <CreditCard size={20} />,
    title: "4. Payments & Payouts",
    text: "Payments for completed jobs are processed securely through Picks4Tips. Service responders must connect their payout account to receive earnings. Platform fees or commissions may apply where applicable, and payouts are released according to the platform's payment process.",
  },
  {
    icon: <Ban size={20} />,
    title: "5. Acceptable Use",
    text: "Users must not engage in fraudulent activities, provide false information, abuse other users, manipulate reviews, or attempt to bypass the Picks4Tips platform for payments or bookings. Any violation may result in account suspension or permanent removal.",
  },
 {
  icon: <RefreshCw size={20} />,
  title: "5. Dispute Resolution",
  text: "If a dispute arises between a seeker and a service responder regarding a job or payment, Picks4Tips may review the available evidence, including messages, uploaded proof, and other relevant information. Our team will evaluate the dispute and make a fair decision based on the information provided by both parties.",
},
  {
    icon: <AlertCircle size={20} />,
    title: "7. Limitation of Liability",
    text: "Picks4Tips provides a platform that connects seekers with independent service responders. While we strive to maintain a trusted marketplace through verification and monitoring, Picks4Tips is not responsible for the quality, safety, or outcome of services provided by independent responders.",
  },
];

const TermsConditions = () => {
  const itemRefs = useRef([]);

  useEffect(() => {
    const observers = [];

    itemRefs.current.forEach((el, i) => {
      if (!el) return;
      const obs = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add('tc-item--visible');
            obs.disconnect();
          }
        },
        { threshold: 0.15 }
      );
      obs.observe(el);
      observers.push(obs);
    });

    return () => observers.forEach(o => o.disconnect());
  }, []);

  return (
    <>
    <ScrollToTop/>
    <Topbar/>
    <MyNavbar/>
    <div className="tc-page">
      <div className="tc-container">

        {/* Header */}
        <div className="tc-header">
          <h2 className="tc-main-title">Terms &amp; Conditions</h2>
          <p className="tc-updated">Last updated: March 2026</p>
          <p className="tc-intro">
            Welcome to Picks4Tips. These terms and conditions outline the rules and regulations
            for the use of our platform. Please read them carefully before using our services.
          </p>
        </div>

        {/* Sections */}
        <div className="tc-list">
          {SECTIONS.map((sec, i) => (
            <div
              key={i}
              className="tc-item"
              ref={el => (itemRefs.current[i] = el)}
              style={{ transitionDelay: `${i * 0.07}s` }}
            >
              {/* Icon + vertical line */}
              <div className="tc-item__left">
                <div className="tc-item__icon">{sec.icon}</div>
                {i < SECTIONS.length - 1 && <div className="tc-item__line" />}
              </div>

              {/* Content */}
              <div className="tc-item__content">
                <h5 className="tc-item__title">{sec.title}</h5>
                <p className="tc-item__text">{sec.text}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
    <Myfooter/>
    </>
  );
};

export default TermsConditions;